import { Component, OnInit, AfterContentInit, OnDestroy } from '@angular/core';
import { SharedService } from '../services/shared.service';
import { Subscription } from 'rxjs';
import {
  MatDialog,
  MatSnackBar
} from '@angular/material';
import {
  Router
} from '@angular/router';
import { AddNewAccountFederalGovernmentPukalDialog } from '../app/manage-pukal/ptj-list/federal-government/dialog.addnewaccount';
import { AddNewAccountOtherGovernmentPukalDialog } from '../app/manage-pukal/ptj-list/other-government/dialog.addnewaccount';
import { AddNewAccountPukalStateGovernmentDialog } from '../app/manage-pukal/ptj-list/state-government/dialog.addnewaccount';
import { AddNewAccountPukalSarawakGovernmentDialog } from '../app/manage-pukal/ptj-list/swk-government/dialog.addnewaccount';
import { AddMissingTransactionDialog } from '../app/transaction/billing/dialog.addmissing';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterContentInit, OnDestroy {
  userName: string = '';
  screenCode: string = '';
  isUserLoggedIn: boolean = false;
  allSub: Subscription[] = [];
  isAdminActive: boolean = false;
  isReportActive: boolean = false;
  isTransactionActive: boolean = false;
  isManagePukalActive: boolean = false;
  loading: boolean = true;
  title: string = '';

  public adminOnClick() {
    this.isAdminActive = !this.isAdminActive;
    this.isManagePukalActive = false;
    this.isTransactionActive = false;
    this.isReportActive = false;
  }
  public managePukalOnClick() {
    this.isManagePukalActive = !this.isManagePukalActive;
    this.isAdminActive = false;
    this.isTransactionActive = false;
    this.isReportActive = false;
  }
  public transactionOnClick() {
    this.isTransactionActive = !this.isTransactionActive;
    this.isAdminActive = false;
    this.isManagePukalActive = false;
    this.isReportActive = false;
  }
  public reportOnClick() {
    this.isReportActive = !this.isReportActive;
    this.isAdminActive = false;
    this.isManagePukalActive = false;
    this.isTransactionActive = false;
  }

  constructor(private router: Router, public dialog: MatDialog, public snackBar: MatSnackBar) {
    // let sub = router.events.subscribe((event: RouterEvent) => {
    //   this.navigationInterceptor(event);
    // });

    // // Adds into array for each subscribe
    // this.allSub.push(sub);
  }

  addNewFedAcc(): void {
    let dialogRef = this.dialog.open(AddNewAccountFederalGovernmentPukalDialog, {
      width: '60%',
      disableClose: true,
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Add new successful') {
        this.openSnackBar('Add new account successful.', '');
      }
    });
  }

  addNewOtherAcc(): void {
    let dialogRef = this.dialog.open(AddNewAccountOtherGovernmentPukalDialog, {
      width: '80%',
      disableClose: true,
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Add new successful') {
        this.openSnackBar('Add new account successful.', '');
      }
    });
  }

  addNewNGRAcc(): void {
    let dialogRef = this.dialog.open(AddNewAccountPukalStateGovernmentDialog, {
      width: '60%',
      disableClose: true,
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Add new successful') {
        this.openSnackBar('Add new account successful.', '');
      }
    });
  }

  addNewSwkAcc(): void {
    let dialogRef = this.dialog.open(AddNewAccountPukalSarawakGovernmentDialog, {
      width: '60%',
      disableClose: true,
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Add new successful') {
        this.openSnackBar('Add new account successful.', '');
      }
    });
  }

  addFedMissingBilling(): void {
    let dialogRef = this.dialog.open(AddMissingTransactionDialog, {
      width: '60%',
      disableClose: true,
      data: {
        warrantauthcode: 'JA'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'close') {
      }
    });
  }

  addOthMissingBilling(): void {
    let dialogRef = this.dialog.open(AddMissingTransactionDialog, {
      width: '60%',
      disableClose: true,
      data: {
        warrantauthcode: 'OT'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'close') {
      }
    });
  }

  addStateMissingBilling(): void {
    let dialogRef = this.dialog.open(AddMissingTransactionDialog, {
      width: '60%',
      disableClose: true,
      data: {
        warrantauthcode: 'NG'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'close') {
      }
    });
  }

  addSWMissingBilling(): void {
    let dialogRef = this.dialog.open(AddMissingTransactionDialog, {
      width: '60%',
      disableClose: true,
      data: {
        warrantauthcode: 'SW'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'close') {
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }

  ngAfterContentInit() {
    let sub = SharedService.get(SharedService.AfterLogIn)
      .subscribe((data: any) => {
        if (data) {
          this.isUserLoggedIn = data.isUserLoggedIn;
          this.userName = data.username;
          this.screenCode = data.screenCode;
        }
      });

    // Adds into array for each subscribe
    this.allSub.push(sub);
  }

  // Unsubscribe service on screen change
  ngOnDestroy() {
    for (let sub of this.allSub) {
      sub.unsubscribe();
    }
  }
}
